import AgendasApi from './agenda'

export const AgendaApi = {
  async getAgenda(dateRange) {
    return await AgendasApi.getAgenda(dateRange)
  },

  async getScheduleConfig(scheduleId) {
    return await AgendasApi.getScheduleConfig(scheduleId)
  },

  async getObjetivos() {
    return await AgendasApi.getObjetivos()
  },

  async getMateriais() {
    return await AgendasApi.getMateriais()
  },

  async listarDisciplinasCursos() {
    return await AgendasApi.listarDisciplinasCursos()
  },

  async create(scheduleConfig) {
    return await AgendasApi.create(scheduleConfig)
  },

  async update(scheduleConfig) {
    return await AgendasApi.update(scheduleConfig)
  },

  async delete(cronogramaId) {
    return await AgendasApi.delete(cronogramaId)
  },

  async getTempoTotalConteudo(agendaConfig) {
    return await AgendasApi.getTempoTotalConteudo(agendaConfig)
  }
}

export default AgendaApi
